import { userAuthenticat, menus } from '@/api'
import { GET_LOGIN_HELP_TEXT } from '@/store/actions.type'
import { SAVE_LOGIN_HELP_TEXT } from '@/store/mutations.type'
const urlParam = getAllUrlParams()
const state = {
  errors: null,
  panaray: checkclientype(),
  theme: clientTheme(),
  encemail: userEncEmail(),
  logintext: '',
  loginhelpLoading: true
}
const actions = {
  [GET_LOGIN_HELP_TEXT]( { commit } ) {
    return menus.getlogintext().then( ( { data } ) => {
      commit( SAVE_LOGIN_HELP_TEXT, data )
    } )
  }
}
const mutations = {
  [SAVE_LOGIN_HELP_TEXT]( state, loginhelptext ) {
    state.loginhelp = loginhelptext
    state.loginhelpLoading = false
  }
}
function clientTheme() {
  // console.log(urlParam.t)
  if ( urlParam.t ) {
    if ( typeof urlParam.t === 'object' ) {
      return urlParam.t[urlParam.t.length - 1]
    } else {
      return urlParam.t
    }
  }
  return 'l'
}
function userEncEmail() {
  if ( urlParam.e ) {
    if ( typeof urlParam.e === 'object' ) {
      return urlParam.e[urlParam.e.length - 1]
    } else {
      return urlParam.e
    }
  }
  return ''
}
function checkclientype() {
  var encemailid = ''
  if ( urlParam.e ) {
    if ( typeof urlParam.e === 'object' ) {
      encemailid = urlParam.e[urlParam.e.length - 1]
    } else {
      encemailid = urlParam.e
    }
    userAuthenticat.login( encemailid, 'userData_p' )
    dtm['panarayServed'] = 1
    dtm['panarayHost'] = 'yes'
    return true
  }
  dtm['panarayHost'] = 'no'
  return false
}
function getAllUrlParams() {
  var url = window.location.href
  // get query string from url (optional) or window
  var queryString = url ? url.split( '?' )[1] : window.location.search.slice( 1 )

  // we'll store the parameters here
  var obj = {}

  // if query string exists
  if ( queryString ) {
    queryString = queryString.split( '#' )[0]
    var arr = queryString.split( '&' )
    for ( var i = 0; i < arr.length; i++ ) {
      var a = arr[i].split( '=' )
      var paramNum
      var paramName = a[0].replace( /\[\d*\]/, function ( v ) {
        paramNum = v.slice( 1, -1 )
        return ''
      } )
      var paramValue = typeof a[1] === 'undefined' ? true : a[1]
      if ( obj[paramName] ) {
        // convert value to array (if still string)
        if ( typeof obj[paramName] === 'string' ) {
          obj[paramName] = [obj[paramName]]
        }
        if ( typeof paramNum === 'undefined' ) {
          obj[paramName].push( paramValue )
        } else {
          obj[paramName][paramNum] = paramValue
        }
      } else {
        obj[paramName] = paramValue
      }
    }
  }
  return obj
}

/*
const getters = {
  currentUser (state) {
    return state.user
  },
  isAuthenticated (state) {
    return state.tokenId !== null
  }
}
export default {
  state,
  getters
}
*/

export default {
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/app.settings.js